<template>
  <div class="collapse_air">
    <ul class="head" :class="[show && 'open']">
        <li class="clearfix">
            <span class="arrow" @click="show = !show">
                <i class="iconfont icon-xiajiantou" ></i>  
            </span>
            <span class="c_no">{{air.id}}</span>
            <span class="no">{{air.deviceId}}</span>
            <span class="cat">{{air.name}}</span>
            <span class="last_update">{{air.deviceUpdatetime}}</span>
            <span class="meter">{{air.electricalDegree}}KW/h</span>
            <span class="open_count">{{}}</span>
            <span class="close_count">{{}}</span>
            <span class="device_state">
              <base-state :state="air.onlineStat"></base-state>
            </span>
            <span class="btn_group">
                <button class="detail" @click="$emit('viewsingle', air)">查看</button>
            </span>
        </li>
    </ul>
    <el-collapse-transition>
      <ul v-show="show" class="collapse_body">
        <li class="clearfix" v-for="(node, index) in air.node_data" :key="index">
            <span class="arrow">
                <i class="iconfont icon-xiajiantou" style="visibility:hidden"></i>  
            </span>
            <span class="c_no">{{node.id}}</span>
            <span class="no">--</span>
            <span class="cat">{{node.node_type}}</span>
            <span class="last_update">--</span>
            <span class="meter">{{node.node_ps}}KW/h</span>
            <span class="open_count">{{node.node_switch_open}}</span>
            <span class="close_count">{{node.node_switch_close}}</span>
            <span class="device_state">--</span>
            <span class="btn_group">--</span>
          </li>
        </ul>
    </el-collapse-transition>
  </div>
</template>

<script>
export default {
  props: ['air'],
  data(){
    return {
      show: false
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/component/base-air-tabledevice.vue